import { ContentType } from '@mode/notebooks/contract';
import { createAction, props } from '@ngrx/store';
import { OrderedSet } from 'immutable';

export const editCellContent = createAction('[Cell] EditCellContent', props<{ content: string; cellToken: string }>());
export const beginEditCell = createAction('[Cell] BeginEdit', props<{ cellToken: string; cellFrozen: boolean }>());
export const UpdateContentType = createAction(
  '[Cell] UpdateContentType',
  props<{ contentType: ContentType; cellToken: string }>()
);
export const updateCell = createAction('[Cell] Update', props<{ cellToken: string }>());

export const selectCell = createAction('[Cell] Select', props<{ cellToken: string; resultPane: boolean }>());

export const addCell = createAction(
  '[Cell] Add',
  props<{ notebookToken: string; content?: string; contentType?: string; nextToken?: string }>()
);

export const moveCell = createAction(
  '[Cell] MoveCell',
  props<{ cellToken: string; notebookToken: string; down: boolean }>()
);

export const addCellToLayout = createAction('[Cell] AddToLayout', props<{ cellToken: string }>());

export const foldCell = createAction('[Cell] Fold', props<{ cellToken: string }>());

export const toggleFreezeCell = createAction('[Cell] ToggleFreezeCell', props<{ cellToken: string }>());

export const removeCellFromLayout = createAction(
  '[Cell] RemoveFromLayout',
  props<{ cellToken: string; vizToken: string }>()
);

export const destroyCell = createAction(
  '[Cell] Destroy',
  props<{
    cellToken: string;
    nextCellToken: string;
    notebookToken: string;
    notebookCellTokensArray: Map<string, OrderedSet<string>>;
  }>()
);
